// Whether the signed-in user is an invited course creator (profiles.is_creator).
// Creators are workspace-only: DashboardPage uses this to route them to
// /creator instead of the learner dashboard. Resolves false on any read error
// (e.g. migration 114 not applied yet) — the redirect is a convenience, the
// workspace gate itself is server-side.
import { useEffect, useState } from "react";
import { useAuth } from "@/shared/contexts/AuthContext";
import { supabase } from "@/shared/lib/supabase";

export function useIsCreator(): { isCreator: boolean; loading: boolean } {
  const { user } = useAuth();
  const [state, setState] = useState<{ isCreator: boolean; loading: boolean }>({
    isCreator: false,
    loading: true,
  });

  useEffect(() => {
    if (!user) {
      setState({ isCreator: false, loading: false });
      return;
    }
    let alive = true;
    supabase
      .from("profiles")
      .select("is_creator")
      .eq("user_id", user.id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (!alive) return;
        setState({
          isCreator: !error && data?.is_creator === true,
          loading: false,
        });
      });
    return () => {
      alive = false;
    };
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return state;
}
